var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9628 23.5249C11.7253 23.5249 11.4878 23.4374 11.3003 23.2499L3.71279 15.6624C3.35029 15.2999 3.35029 14.6999 3.71279 14.3374L11.3003 6.7499C11.6628 6.3874 12.2628 6.3874 12.6253 6.7499C12.9878 7.1124 12.9878 7.7124 12.6253 8.0749L5.70029 14.9999L12.6253 21.9249C12.9878 22.2874 12.9878 22.8874 12.6253 23.2499C12.4503 23.4374 12.2003 23.5249 11.9628 23.5249Z",
    fill: "#0A0F16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6249 15.9375H4.5874C4.0749 15.9375 3.6499 15.5125 3.6499 15C3.6499 14.4875 4.0749 14.0625 4.5874 14.0625H25.6249C26.1374 14.0625 26.5624 14.4875 26.5624 15C26.5624 15.5125 26.1374 15.9375 25.6249 15.9375Z",
    fill: "#0A0F16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.ca3ff0abb3765ea64ee7fd086902f68e.svg";
export { ForwardRef as ReactComponent };